import QuantizationInLLMsContent from './content/quantization-in-llms-content';
import BlogPost from '../blogpost';

export default function QuantizationInLLMs() {
  return <BlogPost post={QuantizationInLLMsContent} />;
}